import { Typography } from '@mui/material';
import { Drawer } from 'src/components/drawer';
import { SidebarHeader } from 'src/components/header';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { IScreen } from 'src/interfaces';
import { lang } from 'src/utils';

import {
  CheckIcon,
  ScheduleComponentButton,
  ScreenTextWrapper,
  ScreenWrapper,
  SidebarContainer,
  StyledAlert,
  StyledWarningIcon,
} from './ScreensDrawer.styled';

export interface IScreensDrawer {
  layerIndex: number;
  showScreensDrawer: boolean;
  screens: (IScreen & { disabled?: boolean })[];
  options?: {
    showAlertBox?: boolean;
    overrideButtonTitle?: string;
    buttonsEnabled?: boolean[];
  };
  onCloseScreensDrawer: () => void;
  onScheduleScreenComponent: (screenIndex: number) => void;
  hadScheduledAllSections?: (
    layerIndex: number,
    screenIndex: number,
  ) => boolean;
  hasComponentsWithoutStartDate?: (
    layerIndex: number,
    screenIndex: number,
  ) => boolean;
  hasInvalidBackups?: (layerIndex: number, screenIndex: number) => boolean;
}

export const defaultDrawerProps = {
  PaperProps: {
    sx: {
      border: 'none',
    },
  },
};

export const ScreensDrawer = (props: IScreensDrawer) => {
  const {
    screens,
    showScreensDrawer,
    layerIndex,
    options,
    hadScheduledAllSections,
    hasComponentsWithoutStartDate,
    onCloseScreensDrawer,
    onScheduleScreenComponent,
    hasInvalidBackups,
  } = props;

  const showAlertBox = options?.showAlertBox ?? true;

  const handleCloseDrawer = () => {
    onCloseScreensDrawer();
  };

  const handleScheduleScreenComponent = (screenIndex: number) => {
    onScheduleScreenComponent(screenIndex);
  };

  return (
    <Drawer open={showScreensDrawer} {...defaultDrawerProps}>
      {showScreensDrawer && (
        <>
          <SidebarHeader
            label={`${lang.position} ${layerIndex}`}
            onBackClick={handleCloseDrawer}
          />
          <SidebarContainer>
            {showAlertBox && (
              <StyledAlert severity="info" icon={false}>
                {lang.scheduleComponent.createSectionTips}
              </StyledAlert>
            )}

            {screens.map((screen, index) => (
              <ScreenWrapper key={index}>
                <ScreenTextWrapper>
                  <Typography>{`${lang.screen} ${index + 1}`}</Typography>
                  {hasComponentsWithoutStartDate?.(layerIndex, index) ||
                  hasInvalidBackups?.(layerIndex, index) ? (
                    <CustomTooltip
                      placement="right"
                      skipValidateOverflow
                      title={lang.componentRequireStartDate}>
                      <StyledWarningIcon data-testid={'WarningIcon'} />
                    </CustomTooltip>
                  ) : hadScheduledAllSections?.(layerIndex, index) ? (
                    <CheckIcon color="success" />
                  ) : null}
                </ScreenTextWrapper>
                <ScheduleComponentButton
                  data-testid={`screen-schedule-component-${index + 1}`}
                  variant="outlined"
                  disabled={screen.disabled}
                  onClick={() => handleScheduleScreenComponent(index)}>
                  {options?.overrideButtonTitle
                    ? options.overrideButtonTitle
                    : hadScheduledAllSections?.(layerIndex, index)
                    ? lang.editSchedule
                    : lang.scheduleComponent.label}
                </ScheduleComponentButton>
              </ScreenWrapper>
            ))}
          </SidebarContainer>
        </>
      )}
    </Drawer>
  );
};
